module.exports = __webpack_public_path__ + "img/kcn.e3d69ad0.png";